<app-consult-note-history-item-title>
  {{ title }}
</app-consult-note-history-item-title>
<app-consult-note-history-item-body>
  <p>
    {{ description }}
  </p>
</app-consult-note-history-item-body>
